import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Modal, ModalFooter } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';

function ConfirmChangeTemplateTypeModal({
  onClose,
  open,
  onChangeTemplateType,
}) {
  const renderFooter = () => {
    return (
      <ModalFooter>
        <Button
          id="confirm-change-template-type-modal-btn"
          buttonStyle="primary"
          onClick={() => onChangeTemplateType()}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.confirm"
            defaultMessage="Confirm"
          />
        </Button>
        <Button
          id="confirm-change-template-type-modal-cancel-btn"
          onClick={onClose}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  return (
    <Modal
      id="confirm-change-template-type-modal"
      open={open}
      onClose={onClose}
      footer={renderFooter()}
      label={
        <Icon icon="replace" size="large">
          <FormattedMessage
            id="ui-plugin-inventory-templates.confirmChangeTemplateTypeModal.label"
            defaultMessage="Confirm change template type"
          />
        </Icon>
      }
      dismissible
    >
      <strong>
        <FormattedMessage
          id="ui-plugin-inventory-templates.confirmChangeTemplateTypeModal.msg1"
          defaultMessage="Are you sure you want to change the instance template type?"
        />
        <br />
        <FormattedMessage
          id="ui-plugin-inventory-templates.confirmChangeTemplateTypeModal.msg2"
          defaultMessage="If you confirm, You may lost some data in the record."
        />
      </strong>
    </Modal>
  );
}

ConfirmChangeTemplateTypeModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onChangeTemplateType: PropTypes.func,
};

export default ConfirmChangeTemplateTypeModal;
